// https://switcheroo.atlassian.com/ui/gates/f0c8695a-3334-4f50-99e2-cecd6570ea6d/key/atlassian_projects_-_native_integration
export const PROJECTS_NATIVE_INTEGRATION_WITH_JIRA = 'atlassian_projects_-_native_integration';

// https://switcheroo.atlassian.com/ui/gates/714d36e0-d971-4221-9888-23c4682396aa/key/townsquare_remove_apps_from_fyp
// Poster: https://hello.atlassian.net/wiki/spaces/STATUS/pages/6402034501/Experiment+plan+Remove+Your+apps+from+Home+s+For+you+page
export const REMOVE_APPS_FROM_FYP_EXPERIMENT = 'townsquare_remove_apps_from_fyp';

// Verified teams in for you experiment - exposure only fires when recommendedTeams query has results
export const VERIFIED_TEAMS_IN_FOR_YOU_EXPERIMENT = 'verified_teams_in_for_you';

// Teams recommendations for you experiment - exposure only fires when rovo teams recommendations are cached.
export const TEAMS_RECOMMENDATIONS_FOR_YOU_EXPERIMENT = 'recommended_teams_in_for_you_page';

export const USER_PROFILE_REFRESH_EXPERIMENT = 'user_profile_refresh_experiment';

// https://switcheroo.atlassian.com/ui/gates/5df9f216-7f3c-4f54-a2c7-67873439d0ac/key/jira-space-invite-teams-app
export const JIRA_SPACE_INVITE_TEAMS_APP = 'jira-space-invite-teams-app';

// Extension CTA on site home (For you). Statsig: experiment `extension-cta-site-home`, param `isAbleToViewCTA` (string: control | variantA | variantB; default control).
export const EXTENSION_CTA_SITE_HOME_EXPERIMENT = 'extension-cta-site-home';

/** Must match Statsig / Switcheroo dynamic config parameter name. */
export const EXTENSION_CTA_SITE_HOME_IS_ABLE_TO_VIEW_CTA_PARAM = 'isAbleToViewCTA' as const;

/** Cohort for `extension-cta-site-home` / `isAbleToViewCTA`. Values must match Statsig. */
export enum ExtensionCtaSiteHomeCohort {
	Control = 'control',
	VariantA = 'variantA',
	VariantB = 'variantB',
}

// https://switcheroo.atlassian.com/ui/gates/06a7b503-f3af-43f5-bb9b-5db4718afcc8/key/townsquare_rovofied_greeting
export const ROVOFIED_GREETING_EXPERIMENT = 'townsquare_rovofied_greeting';

export const NEW_HOME_CHAT_BOX_EXP = 'new_rovo_in_home_exp';
export const ROVO_TOWNSQ_EMPTY_STATE_GET_PROJECT_DETAILS_SKILL = 'rovo_townsq_empty_state_get_project_details_skill';

// Make sure you add your experiment to the list of valid experiments
export const experiments = {
	REMOVE_APPS_FROM_FYP_EXPERIMENT,
	PROJECTS_NATIVE_INTEGRATION_WITH_JIRA,
	VERIFIED_TEAMS_IN_FOR_YOU_EXPERIMENT,
	TEAMS_RECOMMENDATIONS_FOR_YOU_EXPERIMENT,
	USER_PROFILE_REFRESH_EXPERIMENT,
	EXTENSION_CTA_SITE_HOME_EXPERIMENT,
	JIRA_SPACE_INVITE_TEAMS_APP,
	ROVOFIED_GREETING_EXPERIMENT,
	NEW_HOME_CHAT_BOX_EXP,
	ROVO_TOWNSQ_EMPTY_STATE_GET_PROJECT_DETAILS_SKILL,
} as const;

export type ExperimentKeys = keyof typeof experiments;
export type ExperimentNames = (typeof experiments)[ExperimentKeys];
